import { type Breadcrumb } from "../types/Breadcrumb"

export function usePreviousPage(breadcrumbs: Array<Breadcrumb>) {
    const [_currentPage, previousPage] = [...breadcrumbs].reverse()

    return previousPage
}
